import { QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { useRef } from "react";

import { createQueryClient } from "../lib/queryClient";
import { ApiClientProvider } from "./ApiClientProvider";
import { AuthBootstrap } from "../features/auth/AuthBootstrap";
import { ForceUpdateBootstrap } from "../features/forceUpdate/ForceUpdateBootstrap";
import { ForceUpdateModal } from "../features/forceUpdate/ForceUpdateModal";
import { NotificationProvider } from "./NotificationProvider";
import { AnalyticsProvider } from "./AnalyticsProvider";
import { FeatureFlagProvider } from "./FeatureFlagProvider";
import { AnalyticsIdentity } from "../features/analytics/AnalyticsIdentity";
import { ModalStackProvider } from "./ModalStackProvider";
import { TutorialProvider } from "./TutorialProvider";

export function AppProviders({ children }: { children: ReactNode }) {
  const queryClientRef = useRef(createQueryClient());

  return (
    <QueryClientProvider client={queryClientRef.current}>
      <FeatureFlagProvider>
        <AnalyticsProvider>
          <NotificationProvider>
            <ModalStackProvider>
              <ApiClientProvider>
                <TutorialProvider>
                  <AuthBootstrap />
                  <ForceUpdateBootstrap />
                  <ForceUpdateModal />
                  <AnalyticsIdentity />
                  {children}
                </TutorialProvider>
              </ApiClientProvider>
            </ModalStackProvider>
          </NotificationProvider>
        </AnalyticsProvider>
      </FeatureFlagProvider>
    </QueryClientProvider>
  );
}
